export const Logo = ({ className = "", dark = false }) => {
  const stroke = dark ? "#FDFBF7" : "#1A4F36";
  const ink = dark ? "#FDFBF7" : "#1A1A1A";
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <svg width="26" height="26" viewBox="0 0 40 40" fill="none" className="shrink-0">
        <circle cx="20" cy="20" r="18" stroke={stroke} strokeWidth="2" />
        <g stroke={stroke} strokeWidth="2" strokeLinejoin="round">
          <path d="M20 4 L26 14 L14 14 Z" />
          <path d="M36 20 L26 26 L26 14 Z" />
          <path d="M20 36 L14 26 L26 26 Z" />
          <path d="M4 20 L14 14 L14 26 Z" />
        </g>
        <circle cx="20" cy="20" r="5" fill={stroke} />
      </svg>
      <span className="font-serif leading-none tracking-tight" style={{ color: ink }}>
        <span className="block text-[15px] sm:text-[17px]">The Event Club</span>
      </span>
    </span>
  );
};
